export class Address {
	postcode: string;
	sub_building: string;
	house_name: string;
	house_number: string;
	address_line_1: string;
	address_line_2: string;
	address_line_3: string;
	town: string;
	county: string;
}
